// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"356":"e27247fc","453":"227451d7","563":"e9728518","628":"af836bc8","665":"1cb3f2ca","692":"ea5e6d41","708":"d3fbb261"}[chunkId] + ".chunk.js";
};